window.Products.Scarf = {};
window.Products.Scarf.Scarf = function() {};
window.Products.Scarf.Scarf.inherits(window.Products.Product);
window.Products.Scarf.Scarf.dpi = 150;